import basketSummary from './basket_summary.template.html';

angular.module('bl.basket').component('blBasketSummary', {
    controller: ['$scope', '$rootScope', basketSummaryController],
    controllerAs: '$basketSummaryCtrl',
    templateUrl: basketSummary.id,
    bindings: {
        basketItems: '<'
    }
});

function basketSummaryController($scope, $rootScope, BBModel) {
    let parentScope = $scope.$parent.$parent;

    let self = this;
    $scope.$on('basket:updated', function (event, basket) {
        self.basketItems = parentScope.basket.items.filter(item => !item.is_coupon);
        $rootScope.$broadcast('basket-items', parentScope.basket);

    });

    if (parentScope.basket.items) {
        this.basketItems = parentScope.basket.items;
        $rootScope.$broadcast('basket-items', parentScope.basket);
    }

    this.showPage = function (route) {
        $scope.$parent.$parent.showPage(route);
    };
}


// WEBPACK FOOTER //
// src/public/javascripts/basket/summary/basket_summary.component.js